import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import Layout from './components/common/Layout';
import Home from './pages/Home';
import { useGoogleAnalytics } from "./hooks/useGoogleAnalytics";

// Lazy load tool pages to improve initial load time
const CaseConverter = React.lazy(() => import('./pages/CaseConverter'));
const GitHelper = React.lazy(() => import('./pages/GitHelper'));
const JiraTicketCreator = React.lazy(() => import('./pages/JiraTicketCreator'));
const DiffTool = React.lazy(() => import('./pages/DiffTool'));
const ListTool = React.lazy(() => import("./pages/ListTool"));
const JsonYamlConverter = React.lazy(() => import("./pages/JsonYamlConverter"));
const UuidGenerator = React.lazy(() => import("./pages/UuidGenerator"));
const ImageResizer = React.lazy(() => import("./pages/ImageResizer"));
const ReactGenerator = React.lazy(() => import("./pages/ReactGenerator"));
const About = React.lazy(() => import("./pages/About"));
const Contact = React.lazy(() => import("./pages/Contact"));
const Privacy = React.lazy(() => import("./pages/Privacy"));

// Loading component for lazy-loaded routes
const LoadingFallback = () => (
    <div className="flex items-center justify-center h-screen bg-white dark:bg-primary">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-secondary"></div>
    </div>
);

function App() {
    // Initialize Google Analytics route tracking
    useGoogleAnalytics();

    return (
        <ThemeProvider>
            <Layout>
                <React.Suspense fallback={<LoadingFallback />}>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route
                            path="/case-converter"
                            element={<CaseConverter />}
                        />
                        <Route path="/git-helper" element={<GitHelper />} />
                        <Route
                            path="/jira-creator"
                            element={<JiraTicketCreator />}
                        />
                        <Route path="/diff-tool" element={<DiffTool />} />
                        <Route
                            path="/duplicate-remover"
                            element={<ListTool />}
                        />
                        <Route
                            path="/json-yaml-converter"
                            element={<JsonYamlConverter />}
                        />
                        <Route
                            path="/uuid-generator"
                            element={<UuidGenerator />}
                        />
                        <Route
                            path="/image-resizer"
                            element={<ImageResizer />}
                        />
                        <Route
                            path="/react-generator"
                            element={<ReactGenerator />}
                        />
                        <Route path="/about" element={<About />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/privacy" element={<Privacy />} />
                        {/* Add additional routes here as you create more tools */}
                    </Routes>
                </React.Suspense>
            </Layout>
        </ThemeProvider>
    );
}

export default App;
